/* Konko: reproduce en autoplay (muted) el video de la 2da multimedia
   al pasar el cursor sobre la tarjeta de producto, solo para el/los
   producto(s) que el snippet product-grid-item.liquid marque con
   [data-hover-video-wrapper] / [data-hover-video] (hoy: Short 2 en 1
   Perfect Green 4"). No afecta a otros productos ni a la galería de
   la página de producto.

   Delegación en `document` para:
   - funcionar en tarjetas de home y de colecciones (mismo snippet),
   - sobrevivir a re-renders del editor de temas sin duplicar listeners
     (guardado con window.__konkoHoverVideoBound). */
(function () {
  if (window.__konkoHoverVideoBound) return;
  window.__konkoHoverVideoBound = true;

  if (!window.matchMedia) return;

  var supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // En touch (sin hover real) o con prefers-reduced-motion activo,
  // no se engancha ningún listener: la tarjeta se comporta como hoy
  // (solo primera imagen, sin autoplay).
  if (!supportsHover || reducedMotion) return;

  function getVideo(card) {
    return card.querySelector('[data-hover-video]');
  }

  function playVideo(video) {
    if (!video) return;
    try {
      video.currentTime = 0;
    } catch (err) {
      /* metadata puede no estar lista aún; se ignora */
    }
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        /* autoplay bloqueado o interrumpido por un leave rápido: no-op */
      });
    }
  }

  function stopVideo(video) {
    if (!video) return;
    video.pause();
    try {
      video.currentTime = 0;
    } catch (err) {
      /* no-op */
    }
  }

  document.addEventListener('mouseover', function (e) {
    var card = e.target && e.target.closest && e.target.closest('.grid-product__image-mask');
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return; // ya estaba dentro
    playVideo(getVideo(card));
  });

  document.addEventListener('mouseout', function (e) {
    var card = e.target && e.target.closest && e.target.closest('.grid-product__image-mask');
    if (!card) return;
    if (e.relatedTarget && card.contains(e.relatedTarget)) return; // se movió a un hijo interno
    stopVideo(getVideo(card));
  });
})();
